module.exports = __webpack_public_path__ + "img/27-ROT.7ef2f29.jpg";